<div class="row">
    <div *ngIf="showShoppingCart" [ngClass]="(showShoppingCart)?'col-md-6 col-md-push-6 col-sm-12':''">
        <h3 name="payment-method-title">{{'REGISTRATION.STEP.PAYMENT.CART' | translate}}</h3>
        <div class="row">
            <div class="col-md-12">
                <app-shopping-cart [selectedSubscription]="selectedSubscription" [selectedDiscount]="selectedDiscount"
                    [selectedOptions]="selectedOptions" #shoppingCart>
                </app-shopping-cart>
            </div>
        </div>
    </div>
    <div [ngClass]="(showShoppingCart)?'col-md-6 col-md-pull-6 col-sm-12':'col-md-12 col-sm-12'">
        <div *ngIf="!selectedSubscription.alreadyOwnWatch; else other">
            <h3>{{'REGISTRATION.STEP.PAYMENT.TITLE' | translate}}</h3>
        </div>
        <ng-template #other>
            <div *ngIf="!selectedSubscription.alreadyOwnWatch || selectedOptions.length > 0; else justSave">
                <h3>{{'REGISTRATION.STEP.PAYMENT.TITLE' | translate}}</h3>
            </div>
            <ng-template #justSave>
                <h3>{{'REGISTRATION.PAYMENT.SAVE_PAYMENT_INFOS' | translate}}</h3>
            </ng-template>
        </ng-template>
        <div class="col-md-12" class="padding-bottom">
            <mat-button-toggle-group name="paymentButtonGroup" [vertical]="true" [(ngModel)]="type" class="full-width">
                <mat-button-toggle value="card" name="cb" class="full-width center">
                    {{'REGISTRATION.STEP.PAYMENT.CB.NAME' | translate}}
                </mat-button-toggle>
                <mat-button-toggle value="sepa" (click)="setSepaForm()" name="sepa" class="full-width center">
                    {{'REGISTRATION.STEP.PAYMENT.SEPA.NAME' | translate}}
                </mat-button-toggle>
            </mat-button-toggle-group>
        </div>
        <form *ngIf="type==='card'" method="POST" [formGroup]="cardFormGroup">
            <input type="hidden" formControlName="productID">
            <div class="col-md-6 col-sd-12">
                <mat-form-field class="full-width">
                    <mat-label>{{'REGISTRATION.PAYMENT.CARD_NUMBER' | translate}}</mat-label>
                    <input matInput formControlName="number" name="number" autocomplete="cc-number" required
                        class="full-width" type="text" [mask]="paymentMethodValidator.getCardMask()"
                        [validation]="false">
                    <mat-error
                        *ngIf="cardFormGroup.get('number').hasError('required') && cardFormGroup.get('number').touched">
                        {{getErrorMessage('REGISTRATION.PAYMENT.CARD_NUMBER')}}
                    </mat-error>
                    <mat-error
                        *ngIf="cardFormGroup.get('number').hasError('invalidCard') && cardFormGroup.get('number').touched">
                        {{ 'REGISTRATION.FORM.INVALID_CARD_NUMBER' | translate}}
                    </mat-error>
                </mat-form-field>
            </div>
            <div class="col-md-6 col-sm-12">
                <app-display-card-type [cardNumber]="card.number"></app-display-card-type>
            </div>
            <div class="col-md-12">
                <mat-form-field class="full-width">
                    <mat-label>{{'REGISTRATION.PAYMENT.CARD_OWNER' | translate}}</mat-label>
                    <input matInput formControlName="holderName" name="ccname" type="text" size="20"
                        autocomplete="cc-name" required class="full-width">
                    <mat-error
                        *ngIf="cardFormGroup.get('holderName').hasError('required') && cardFormGroup.get('holderName').touched">
                        {{getErrorMessage('REGISTRATION.PAYMENT.CARD_OWNER')}}
                    </mat-error>
                </mat-form-field>
            </div>
            <div class="col-md-4">
                <input type="text" class="workaround" formControlName="expiryMonth" autocomplete="cc-exp-month">
                <mat-form-field class="full-width">
                    <mat-label>{{'REGISTRATION.PAYMENT.EXPIRATION_MONTH' | translate}}</mat-label>
                    <mat-select formControlName="expiryMonth" autocomplete=" cc-exp-month" name="cc-exp-month" required
                        class="mat-primary">
                        <mat-option *ngFor="let month of months" [value]="month">
                            {{month}}
                        </mat-option>
                    </mat-select>
                    <mat-error
                        *ngIf="cardFormGroup.get('expiryMonth').hasError('required') && cardFormGroup.get('expiryMonth').touched">
                        {{getErrorMessage('REGISTRATION.PAYMENT.EXPIRATION_MONTH')}}
                    </mat-error>
                    <mat-error
                        *ngIf="cardFormGroup.get('expiryMonth').hasError('invalidExpiryDate') && cardFormGroup.get('expiryMonth').touched">
                        {{ 'REGISTRATION.FORM.INVALID_EXPIRY_DATE' | translate}}
                    </mat-error>
                </mat-form-field>
            </div>
            <div class="col-md-4">
                <input type="text" class="workaround" formControlName="expiryYear" autocomplete="cc-exp-year">
                <mat-form-field class="full-width">
                    <mat-label>{{'REGISTRATION.PAYMENT.EXPIRATION_YEAR' | translate}}</mat-label>
                    <mat-select formControlName="expiryYear" autocomplete="cc-exp-year" name="cc-exp-year" required
                        class="mat-primary">
                        <mat-option *ngFor="let year of years" [value]="year">
                            {{year}}
                        </mat-option>
                    </mat-select>
                    <mat-error
                        *ngIf="cardFormGroup.get('expiryYear').hasError('required') && cardFormGroup.get('expiryYear').touched">
                        {{getErrorMessage('REGISTRATION.PAYMENT.EXPIRATION_YEAR')}}
                    </mat-error>
                    <mat-error
                        *ngIf="cardFormGroup.get('expiryYear').hasError('invalidExpiryDate') && cardFormGroup.get('expiryYear').touched">
                        {{ 'REGISTRATION.FORM.INVALID_EXPIRY_DATE' | translate}}
                    </mat-error>
                </mat-form-field>
            </div>
            <div class="col-md-4">
                <mat-form-field class="full-width">
                    <mat-label>{{'REGISTRATION.PAYMENT.CODE' | translate}}</mat-label>
                    <input matInput formControlName="cvc" name="cvc" type="text" autocomplete="cc-csc" class="cvc-marg"
                        required>
                    <mat-icon matSuffix [matTooltip]="'REGISTRATION.PAYMENT.INFO_CODE' | translate">info</mat-icon>
                    <mat-error
                        *ngIf="cardFormGroup.get('cvc').hasError('required') && cardFormGroup.get('cvc').touched">
                        {{getErrorMessage('REGISTRATION.PAYMENT.CODE')}}
                    </mat-error>
                    <mat-error
                        *ngIf="cardFormGroup.get('cvc').hasError('invalidCvc') && cardFormGroup.get('cvc').touched">
                        {{ 'REGISTRATION.FORM.INVALID_CODE_NUMBER' | translate}}
                    </mat-error>
                </mat-form-field>
            </div>
        </form>
        <form *ngIf="type==='sepa' && sepaFormGroup" [formGroup]="sepaFormGroup">
            <div class="col-md-12">
                <mat-form-field class="full-width">
                    <mat-label>{{'REGISTRATION.STEP.PAYMENT.SEPA.IBAN' | translate}}</mat-label>
                    <input matInput name="iban" formControlName="iban" type="text" autocomplete="off" appUpperCase
                        required class="full-width" [mask]="paymentMethodValidator.getIbanMask()" [validation]="false">
                    <mat-error
                        *ngIf="sepaFormGroup.get('iban').hasError('required') && sepaFormGroup.get('iban').touched">
                        {{getErrorMessage('REGISTRATION.STEP.PAYMENT.SEPA.IBAN')}}
                    </mat-error>
                    <mat-error
                        *ngIf="sepaFormGroup.get('iban').hasError('invalidIban') && sepaFormGroup.get('iban').touched">
                        {{'REGISTRATION.STEP.PAYMENT.SEPA.IBAN_INVALID' |translate}}
                    </mat-error>
                </mat-form-field>
            </div>
            <div class="col-md-3">
                <mat-form-field class="full-width">
                    <mat-label>{{'COMMON.CIVILITY' | translate}}</mat-label>
                    <mat-select formControlName="gender" name="gender" class="full-width">
                        <mat-option *ngFor="let gender of ['MALE', 'FEMALE']" [value]="gender.toLowerCase()">
                            {{ 'COMMON.'+gender | translate }}
                        </mat-option>
                    </mat-select>
                    <mat-error *ngIf="sepaFormGroup.get('gender').touched && !isValid('gender')">
                        {{getErrorMessage('COMMON.CIVILITY')}}
                    </mat-error>
                </mat-form-field>
            </div>
            <div class="col-md-4">
                <mat-form-field class="full-width">
                    <mat-label>{{'REGISTRATION.STEP.PAYMENT.SEPA.LAST_NAME' | translate}}</mat-label>
                    <input matInput formControlName="lastName" name="lastName" type="text" autocomplete="family-name"
                        required class="full-width">
                    <mat-error *ngIf="sepaFormGroup.get('lastName').touched && !isValid('lastName')">
                        {{getErrorMessage('REGISTRATION.STEP.PAYMENT.SEPA.LAST_NAME')}}
                    </mat-error>
                </mat-form-field>
            </div>
            <div class="col-md-5">
                <mat-form-field class="full-width">
                    <mat-label>{{'REGISTRATION.STEP.PAYMENT.SEPA.FIRST_NAME' | translate}}</mat-label>
                    <input matInput formControlName="firstName" name="firstName" type="text" autocomplete="given-name"
                        required class="full-width">
                    <mat-error *ngIf="sepaFormGroup.get('firstName').touched && !isValid('firstName')">
                        {{getErrorMessage('REGISTRATION.STEP.PAYMENT.SEPA.FIRST_NAME')}}
                    </mat-error>
                </mat-form-field>
            </div>
            <div class="col-md-12" formGroupName="mandateAddress">
                <mat-form-field class="full-width">
                    <mat-label>{{'COMMON.USER_INFO.ADDRESS' | translate}}</mat-label>
                    <app-address-autocomplete name="address" formControlName="addressRaw"
                        (placeChanged)="onAutocompleteSelected($event)"></app-address-autocomplete>
                    <mat-error
                        *ngIf="sepaFormGroup.get('mandateAddress').touched && !sepaFormGroup.get('mandateAddress').get('addressRaw').valid">
                        {{getErrorMessage('REGISTRATION.STEP.PAYMENT.SEPA.ADDRESS') }}
                    </mat-error>
                    <mat-error
                        *ngIf="sepaFormGroup.get('mandateAddress').touched && sepaFormGroup.get('mandateAddress').get('addressRaw').valid && !sepaFormGroup.get('mandateAddress').get('street').valid">
                        {{'REGISTRATION.STEP.PAYMENT.SEPA.ADDRESS_INVALID' | translate }}
                    </mat-error>
                </mat-form-field>
            </div>
        </form>

        <div *ngIf="type===null">
            <h5>{{'REGISTRATION.STEP.PAYMENT.MAKE_PAYMENT_CHOICE' | translate}}</h5>
        </div>
        <div *ngIf="type!==null && showDiscountCode" class="col-md-12 col-sm-12">
            <app-discount-code (emittedValue)="priceCorrection($event)"></app-discount-code>
        </div>
    </div>
</div>
